var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfomenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 13.0302C8.17281 13.0302 7.50006 13.7029 7.50006 14.5302C7.50006 15.3574 8.17281 16.0302 9.00006 16.0302C9.82731 16.0302 10.5001 15.3574 10.5001 14.5302C10.5001 13.7029 9.82731 13.0302 9.00006 13.0302Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 5.53015C9.82731 5.53015 10.5001 4.8574 10.5001 4.03015C10.5001 3.2029 9.82731 2.53015 9.00006 2.53015C8.17281 2.53015 7.50006 3.2029 7.50006 4.03015C7.50006 4.8574 8.17281 5.53015 9.00006 5.53015Z",
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 7.78015C8.17281 7.78015 7.50006 8.4529 7.50006 9.28015C7.50006 10.1074 8.17281 10.7802 9.00006 10.7802C9.82731 10.7802 10.5001 10.1074 10.5001 9.28015C10.5001 8.4529 9.82731 7.78015 9.00006 7.78015Z",
    fill: "#9747FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfomenu);
export default __webpack_public_path__ + "static/media/Info menu.6665cfa222b90c2751d9f575f5063b3a.svg";
export { ForwardRef as ReactComponent };